
import { WorldCountry } from '../types';

export const moroccoExpanded: WorldCountry = {
  name: 'Morocco',
  slug: 'morocco',
  code: 'MA',
  population: 37076584,
  topCities: [
    { name: 'Casablanca', slug: 'casablanca', population: 3359818 },
    { name: 'Rabat', slug: 'rabat', population: 577827 },
    { name: 'Fez', slug: 'fez', population: 1112072 },
    { name: 'Marrakech', slug: 'marrakech', population: 928850 },
    { name: 'Agadir', slug: 'agadir', population: 421844 },
    { name: 'Tangier', slug: 'tangier', population: 947952 },
    { name: 'Meknes', slug: 'meknes', population: 632079 },
    { name: 'Oujda', slug: 'oujda', population: 494252 },
    { name: 'Kenitra', slug: 'kenitra', population: 431282 },
    { name: 'Tetouan', slug: 'tetouan', population: 380787 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'Salé', slug: 'sale', population: 890403 },
    { name: 'Temara', slug: 'temara', population: 313510 },
    { name: 'Mohammedia', slug: 'mohammedia', population: 187708 },
    { name: 'El Jadida', slug: 'el-jadida', population: 194934 },
    { name: 'Khouribga', slug: 'khouribga', population: 196196 },
    { name: 'Beni Mellal', slug: 'beni-mellal', population: 192676 },
    { name: 'Safi', slug: 'safi', population: 308508 },
    { name: 'Nador', slug: 'nador', population: 161726 },
    { name: 'Settat', slug: 'settat', population: 142250 },
    { name: 'Larache', slug: 'larache', population: 125008 },
    { name: 'Ksar el-Kebir', slug: 'ksar-el-kebir', population: 126617 },
    { name: 'Khemisset', slug: 'khemisset', population: 131542 },
    { name: 'Berrechid', slug: 'berrechid', population: 136634 },
    { name: 'Sidi Kacem', slug: 'sidi-kacem', population: 73045 },
    { name: 'Taza', slug: 'taza', population: 148997 },
    { name: 'Ouarzazate', slug: 'ouarzazate', population: 71067 },
    { name: 'Tiznit', slug: 'tiznit', population: 74699 },
    { name: 'Errachidia', slug: 'errachidia', population: 92374 },
    { name: 'Guelmim', slug: 'guelmim', population: 187808 },
    { name: 'Boulemane', slug: 'boulemane', population: 18739 },
    { name: 'Midelt', slug: 'midelt', population: 55304 },
    { name: 'Azrou', slug: 'azrou', population: 54321 },
    { name: 'Ifrane', slug: 'ifrane', population: 73782 },
    { name: 'Imouzzer Kandar', slug: 'imouzzer-kandar', population: 13745 },
    { name: 'Sefrou', slug: 'sefrou', population: 79887 },
    { name: 'Moulay Idriss', slug: 'moulay-idriss', population: 12611 },
    { name: 'Meknes-El Menzeh', slug: 'meknes-el-menzeh', population: 58567 },
    { name: 'Ain Taoujdate', slug: 'ain-taoujdate', population: 34000 },
    { name: 'El Hajeb', slug: 'el-hajeb', population: 23561 },
    { name: 'Khemisset', slug: 'khemisset-alt', population: 45000 },
    { name: 'Sidi Slimane', slug: 'sidi-slimane', population: 78456 },
    { name: 'Souk el Arbaa', slug: 'souk-el-arbaa', population: 89567 },
    { name: 'Sidi Yahya el Gharb', slug: 'sidi-yahya-el-gharb', population: 67123 },
    { name: 'Mechra Bel Ksiri', slug: 'mechra-bel-ksiri', population: 54789 },
    { name: 'Ouazzane', slug: 'ouazzane', population: 59606 },
    { name: 'Chefchaouen', slug: 'chefchaouen', population: 42786 },
    { name: 'Al Hoceima', slug: 'al-hoceima', population: 56716 },
    { name: 'Imzouren', slug: 'imzouren', population: 34567 },
    { name: 'Midar', slug: 'midar', population: 23890 },
    { name: 'Zaio', slug: 'zaio', population: 34123 },
    { name: 'Berkane', slug: 'berkane', population: 109237 },
    { name: 'Ahfir', slug: 'ahfir', population: 23456 },
    { name: 'Bouarfa', slug: 'bouarfa', population: 34567 },
    { name: 'Figuig', slug: 'figuig', population: 12789 },
    { name: 'Jerada', slug: 'jerada', population: 56890 },
    { name: 'Taourirt', slug: 'taourirt', population: 78901 },
    { name: 'Debdou', slug: 'debdou', population: 23456 },
    { name: 'El Aioun Sidi Mellouk', slug: 'el-aioun-sidi-mellouk', population: 34567 },
    { name: 'Bouznika', slug: 'bouznika', population: 34890 },
    { name: 'Ben Slimane', slug: 'ben-slimane', population: 67234 },
    { name: 'Bouskoura', slug: 'bouskoura', population: 78456 },
    { name: 'Tit Mellil', slug: 'tit-mellil', population: 56789 },
    { name: 'Mediouna', slug: 'mediouna', population: 45678 },
    { name: 'Nouaceur', slug: 'nouaceur', population: 34567 },
    { name: 'Skhirat', slug: 'skhirat', population: 23456 },
    { name: 'Ain Harrouda', slug: 'ain-harrouda', population: 67890 },
    { name: 'Sidi Bennour', slug: 'sidi-bennour', population: 45123 },
    { name: 'Azemmour', slug: 'azemmour', population: 38000 },
    { name: 'Bir Jdid', slug: 'bir-jdid', population: 34567 },
    { name: 'Sidi Smai', slug: 'sidi-smai', population: 23456 },
    { name: 'Zemamra', slug: 'zemamra', population: 45678 },
    { name: 'Sebt Gzoula', slug: 'sebt-gzoula', population: 34567 },
    { name: 'Sidi Rahhal', slug: 'sidi-rahhal', population: 23456 },
    { name: 'Oulad Teima', slug: 'oulad-teima', population: 67890 },
    { name: 'Taroudant', slug: 'taroudant', population: 78901 },
    { name: 'Inezgane', slug: 'inezgane', population: 156000 },
    { name: 'Ait Melloul', slug: 'ait-melloul', population: 134567 },
    { name: 'Dcheira El Jihadia', slug: 'dcheira-el-jihadia', population: 89234 },
    { name: 'Biougra', slug: 'biougra', population: 56789 },
    { name: 'Massa', slug: 'massa', population: 34567 },
    { name: 'Chtouka Ait Baha', slug: 'chtouka-ait-baha', population: 45678 },
    { name: 'Tafraout', slug: 'tafraout', population: 23456 },
    { name: 'Igouzdar', slug: 'igouzdar', population: 12345 },
    { name: 'Amizmiz', slug: 'amizmiz', population: 34567 },
    { name: 'Essaouira', slug: 'essaouira', population: 77966 },
    { name: 'Sidi Ifni', slug: 'sidi-ifni', population: 20051 },
    { name: 'Tan-Tan', slug: 'tan-tan', population: 73209 },
    { name: 'Tarfaya', slug: 'tarfaya', population: 6670 },
    { name: 'Laayoune', slug: 'laayoune', population: 217732 },
    { name: 'Boujdour', slug: 'boujdour', population: 46129 },
    { name: 'Dakhla', slug: 'dakhla', population: 106277 },
    { name: 'Aousserd', slug: 'aousserd', population: 7859 },
    { name: 'Smara', slug: 'smara', population: 57035 },
    { name: 'Es-Semara', slug: 'es-semara', population: 34567 },
    { name: 'Bir Lehlou', slug: 'bir-lehlou', population: 12345 },
    { name: 'Mahbes', slug: 'mahbes', population: 23456 },
    { name: 'Farkhana', slug: 'farkhana', population: 8789 },
    { name: 'Mijek', slug: 'mijek', population: 6543 },
    { name: 'Bir Anzarane', slug: 'bir-anzarane', population: 4567 },
    { name: 'Tifariti', slug: 'tifariti', population: 3456 },
    { name: 'Zouerate', slug: 'zouerate', population: 45678 },
    { name: 'Guerguerat', slug: 'guerguerat', population: 2345 },
    { name: 'La Güera', slug: 'la-guera', population: 1234 },
    { name: 'Lagouira', slug: 'lagouira', population: 987 },
    { name: 'Argoub', slug: 'argoub', population: 1876 },
    { name: 'Bir Gandouz', slug: 'bir-gandouz', population: 3456 },
    { name: 'Imlili', slug: 'imlili', population: 2345 },
    { name: 'Tichla', slug: 'tichla', population: 4567 },
    { name: 'Awsard', slug: 'awsard', population: 6789 },
    { name: 'Bir Enzaran', slug: 'bir-enzaran', population: 2134 },
    { name: 'Gleibat el Foula', slug: 'gleibat-el-foula', population: 1876 },
    { name: 'Mahbas', slug: 'mahbas', population: 3254 },
    { name: 'Zag', slug: 'zag', population: 4321 }
  ]
};
